export default "__VITE_ASSET__CtoeMxpp__"